<template>
<v-layout row wrap >
  <v-flex xs12 md4 class='elevation-20 pa-0' >
    <page-toolbar
      @pagetoolbar:homeclicked='homeClicked'
      :initial-extended='false'
      :with-search='false'
      v-model='searchString' >
      <template slot='buttons-after' >
        <v-btn
          @click="openGlobalDialog(true, 'CreateClient')" icon><v-icon>add</v-icon></v-btn>
        <v-btn
          @click="reload" icon><v-icon>replay</v-icon></v-btn>
      </template>
      <template slot='toolbar-right' >
        <v-menu >
          <template v-slot:activator="{ on }">
          <v-btn v-on='on' slot='activator' small icon >
            <v-icon>filter_list</v-icon>
          </v-btn>
          </template>
          <v-list>
            <v-subheader class='overline py-0' >Filter clients in space:</v-subheader>
            <v-list-tile
              v-for="(space, index) in spaces" :key='`${space.id}-${index}`'
              @click='addFilter(space)' >
              <v-list-tile-avatar >
                <v-icon v-if='selectedSpaceId === space.id' small >check</v-icon>
                <v-icon v-else small >radio_button_unchecked</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{space.title}}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </template>
    </page-toolbar>
    <v-card flat >
      <client-list
        @relationshipselected='clientClicked'
        :space-id.sync='selectedSpaceId'
        :include-owned-by-me='false'
        :clear-on-select='false'
        :with-action='true'
        :with-create='false' >
      </client-list>
    </v-card>

    <v-card class='mt-3'  >
      <v-btn @click.native.stop="openGlobalDialog(true, 'CreateClient')" flat >
        <v-icon >add</v-icon> New client
      </v-btn>
    </v-card>
  </v-flex>
  <v-flex xs12 md8 class='hidden-sm-and-down pt-0 pl-2'>
    <!-- <create  ></create> -->
    <client-details
      @close='homeClicked'
      v-if='selectedClient.id' v-model='selectedClient' ></client-details>
    <client-home
      @clientClicked='clientClicked'
      v-else ></client-home>
  </v-flex>
</v-layout>
</template>
<script>
import PageToolbar from '@/components/PageToolbar'
import ClientListItem from '@/components/client/ClientListItem'
import ClientHome from '@/components/pages/ClientHome'
import ClientDetails from '@/components/client/ClientDetails'
import ClientList from '@/components/client/ClientList'
import Create from '@/components/client/Create'
import {SMALL_BREAKPOINT, LIST_CLIENTS_REQ} from '@/store/constants'
import {mapGetters} from 'vuex'

export default {
  name: 'ClientsPage',
  // mixins: [RequestMixin],
  components: { ClientListItem, ClientDetails, Create, PageToolbar, ClientHome, ClientList },
  data () {
    return {
      reqId: LIST_CLIENTS_REQ,
      selectedClient: {},
      selectedSpaceId: null,
      searchString: '',
      create: true,
      maxItems: 30,
      page: 10
    }
  },
  computed: {
    ...mapGetters(['spaces']),
    clients () {
      return this.$store.getters.clients
    },
    filteredClients () {
      let clients = this.clients
      let vm = this
      if (vm.searchString && vm.searchString.length > 0) {
        clients = clients.filter((clientRel) => {
          if (clientRel.client) {
            let client = clientRel.client
            let index = `${client.first_name} ${client.last_name} ${client.email} ${client.phone_number}`
            return (index.toLowerCase()).indexOf(vm.searchString.toLowerCase()) !== -1
          }
        })
      }
      clients = clients.slice(0, this.maxItems)
      return clients
    }
  },
  methods: {
    homeClicked () {
      this.selectedClient = {}
      let width = document.defaultView.innerWidth
      if (width < SMALL_BREAKPOINT) {
        this.$router.push(`/clients/home`)
      }
    },
    clientClicked (client) {
      this.selectedClient = client
      let width = document.defaultView.innerWidth
      if (width < SMALL_BREAKPOINT) {
        // this.$router.push(`/clients/${client.client.id}`)
        this.$router.push(`/clients/r/${client.id}`)
      }
    },
    firstLetter (message) {
      if (message) {
        return message.substr(0, 1)
      }
    },
    reload () {
      this.getClients()
    },
    addFilter (space) {
      if (this.selectedSpaceId === space.id) {
        this.selectedSpaceId = null
      } else {
        this.selectedSpaceId = space.id
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Clients.vue?e032836c